module.exports = __webpack_public_path__ + "static/media/logo.f0aec50a.png";